<template>
  <header class="default-header">

    <div class="header-content">

      <div class="header-title-content">

        <!-- LOGO -->

        <img
          :src="logo"
          alt="HR3 Logo"
          class="header-logo"
          @click="goToFeed"
        />


        <!-- BACK -->

        <button
          type="button"
          class="back-button"
          aria-label="Назад"
          @click="goBack"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M14.5 6.5L9 12L14.5 17.5"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>


        <!-- TITLE -->

        <div class="title-block">

          <h1 class="header-title">
            {{ title }}
          </h1>

          <p class="header-subtitle">
            Это ваш профиль
          </p>

        </div>

      </div>

    </div>

    <div class="header-separator"></div>

  </header>
</template>


<script setup>

import {
  useRouter
} from "vue-router";

import logo
  from "../assets/hr3logo.png";


const props =
  defineProps({

    title: {
      type: String,
      required: true
    }

  });


const router =
  useRouter();


const goBack =
  () => {
    router.back();
  };


const goToFeed =
  () => {
    router.push("/feed");
  };

</script>


<style scoped>

/* ============================================================
   HEADER
============================================================ */

.default-header {
  width: 100%;
  height: 70px;

  flex-shrink: 0;

  position: relative;

  display: flex;
  align-items: center;

  box-sizing: border-box;

  background:
    rgba(24, 24, 24, 0.97);

  z-index: 100;
}


html[data-theme="light"]
.default-header {
  background:
    rgba(255, 255, 255, 0.97);
}


/* ============================================================
   CONTENT
============================================================ */

.header-content {
  width: 100%;

  display: flex;
  align-items: center;

  box-sizing: border-box;

  padding:
    0
    20px;
}


.header-title-content {
  width: 900px;

  margin-left:
    calc(50% - 550px);

  display: flex;
  align-items: center;

  box-sizing: border-box;

  padding:
    0
    20px;
}


/* ============================================================
   LOGO
============================================================ */

.header-logo {
  width: 38px;
  height: auto;

  display: block;

  object-fit: contain;

  flex-shrink: 0;

  margin-left: -160px;
  margin-right: 230px;

  cursor: pointer;

  transition:
    opacity .18s ease,
    transform .18s ease;
}


.header-logo:hover {
  opacity: .82;

  transform:
    translateY(-1px);
}


/* ============================================================
   BACK BUTTON
============================================================ */

.back-button {
  width: 36px;
  height: 36px;

  flex:
    0
    0
    36px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  margin-right: 14px;

  padding: 0;

  color:
    #d8dce2;

  background:
    rgba(255, 255, 255, 0.055);

  border:
    1px solid
    rgba(255, 255, 255, 0.06);

  border-radius:
    11px;

  cursor: pointer;

  transition:
    background-color .18s ease,
    border-color .18s ease,
    color .18s ease,
    transform .18s ease,
    box-shadow .18s ease;
}


.back-button svg {
  width: 18px;
  height: 18px;
}


.back-button:hover {
  color:
    #ffffff;

  background:
    rgba(255, 255, 255, 0.085);

  border-color:
    rgba(255, 255, 255, 0.09);

  transform:
    translateX(-1px);
}


.back-button:active {
  transform:
    scale(.96);
}


html[data-theme="light"]
.back-button {
  color:
    #363c44;

  background:
    #f4f6f8;

  border-color:
    rgba(30, 45, 65, 0.055);

  box-shadow:
    0
    3px
    10px
    rgba(15, 23, 42, 0.035);
}


html[data-theme="light"]
.back-button:hover {
  color:
    #1e242b;

  background:
    #eef1f4;

  border-color:
    rgba(30, 45, 65, 0.075);

  box-shadow:
    0
    5px
    12px
    rgba(15, 23, 42, 0.055);
}


/* ============================================================
   TITLE BLOCK
============================================================ */

.title-block {
  min-width: 0;

  display: flex;
  flex-direction: column;

  gap: 2px;
}


/* ============================================================
   TITLE
============================================================ */

.header-title {
  max-width: 520px;

  margin: 0;

  overflow: hidden;

  color:
    #f0f1f3;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    14px;

  line-height:
    1.2;

  letter-spacing:
    -0.2px;

  white-space:
    nowrap;

  text-overflow:
    ellipsis;
}


html[data-theme="light"]
.header-title {
  color:
    #31363d;
}


/* ============================================================
   SUBTITLE
============================================================ */

.header-subtitle {
  margin: 0;

  color:
    #777d85;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  line-height:
    1.25;

  letter-spacing:
    .05px;
}


html[data-theme="light"]
.header-subtitle {
  color:
    #a1a6ad;
}


/* ============================================================
   SEPARATOR
============================================================ */

.header-separator {
  position: absolute;

  left: 0;
  bottom: 0;

  width: 100%;
  height: 1px;

  background:
    rgba(255, 255, 255, 0.055);
}


html[data-theme="light"]
.header-separator {
  background:
    rgba(25, 40, 60, 0.055);
}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 430px) {

  .default-header {
    height:
      64px;
  }


  .header-content {
    padding:
      0
      14px;
  }


  .header-title-content {
    width:
      100%;

    margin-left:
      0;

    padding:
      0;
  }


  .header-logo {
    width:
      32px;

    margin-left:
      0;

    margin-right:
      16px;
  }


  .back-button {
    width:
      34px;

    height:
      34px;

    flex-basis:
      34px;

    margin-right:
      12px;

    border-radius:
      10px;
  }


  .back-button svg {
    width:
      17px;

    height:
      17px;
  }


  .header-title {
    max-width:
      220px;

    font-size:
      13px;
  }


  .header-subtitle {
    font-size:
      8px;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .header-logo,
  .back-button {
    transition:
      none;
  }

}

</style>